export enum ButtonType {
    MY_ADDRESSES,
    WALLET,
    ACCOUNT_SETTINGS,
    DELIVERY_ADDRESSES,
    MY_RECIPIENTS,
    SET_MONTHLY_LIMITS,
    LOG_OUT,
    PROHIBITED_ITEMS,
    CALCULATE,
    ALL_USERS
}